import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Globals } from '../../../_globals/globals';

import { Location } from '@angular/common';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html'
})

export class NotFoundComponent implements OnInit {

  title: string;
  subtitle: string;

  permissions: string;
  permissionList: any;

  constructor(
    public router: Router,
    private globals: Globals,
    private _location: Location
  ) {}

  ngOnInit() {
    this.title = 'NOT FOUND';
    this.subtitle = 'URL no encontrada';

    console.log('-> -> Iniciando NotFoundComponent:' + this.title);

    this.permissions = localStorage.getItem('permissions');
    console.log('-> -> Iniciando NotFoundComponent permissions:' + this.permissions);

    // No se va a usar en esta sección.
    this.permissionList = this.globals.permissionList; // ['Administrador', 'Supervisor', 'Comercial'];

  }

} // End NotFoundComponent
